import type { VerEnviosIzzaModel } from "../models/verEnviosIzzaModel"
import { VerEnviosIzzaActionsTypes } from "./verEnviosIzzaActions"
import type { VerEnviosIzzaActions } from "./verEnviosIzzaActions"

export function verEnviosIzzaReducer(
    state: VerEnviosIzzaModel,
    action: VerEnviosIzzaActions
): VerEnviosIzzaModel {
    switch (action.type) {
        case VerEnviosIzzaActionsTypes.CARREGAR:
            return {
                ...state,
                enviadas: action.payload.enviadas,
                agendadas: action.payload.agendadas,
            }
        default:
            return state
    }
}
